<template>
  <div id="parkPlaceChar">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          <el-breadcrumb-item>车辆进出统计</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="loadPark"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <!-- @change="loadChannel" -->
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期::">
            <el-date-picker v-model="fDate"
                            style="width:200px"
                            type="date"
                            :clearable="false"
                            placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 20px"></el-col>
    </el-row>
    <div id="main"
         :style="{width:'100%',height:'400px'}"></div>
  </div>
</template>
<script>
import { report as api } from '../../api/report'
import * as park from '../../api/park'

// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/line')
// 引入提示框和标题组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/coord/cartesian/Grid')
require('echarts/lib/coord/cartesian/Axis2D')

export default {
  data () {
    return {
      title: '定制报表',
      form: {},
      is_export: false,
      tableHeight: 0,
      pageCount: 0,
      loading: false,
      cust_list: [],
      park_list: [],
      channel_list: [],
      fDate: '',
      pageSearch: {
        fCustID: '',
        fParkID: '',
        // fChnlID: '',
        fDate: '',
        isExport: 1

      }

    }
  },
  methods: {
    loadPark (fCustID) {
      this.pageSearch.fParkID = ''
      this.park_list = []
      this.pageSearch.fChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    pageDataSet (title, pageData, jsonData) {
      // 基于准备好的dom，初始化echarts实例
      var myChart = echarts.init(document.getElementById('main'))
      // 绘制图表
      myChart.setOption({
        title: {
          text: '车位占比率折线图',
          subtext: title
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            params = params[0]
            return params.name + '点 <br/>占比率：' + params.value + '%<br/>在场车辆：' + jsonData[params.dataIndex].fBusCurCount + '<br/>场库总车位：' + jsonData[params.dataIndex].fParkCount + ''
          }
        },
        xAxis: {
          type: 'category',
          data: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
        },
        yAxis: {
          axisLabel: {
            formatter: function (val) {
              return val + '%'
            }
          },
          type: 'value'
        },
        series: [{
          data: pageData,
          label: {
            normal: {
              show: true,
              position: 'top',
              formatter: function (params) {
                return (params.value).toFixed(2) + '%'
              }
            }
          },
          type: 'line',
          smooth: true
        }]
      })
    },
    page_list () {
      if (this.pageSearch.fCustID.length <= 0) {
        this.$message.error('提示：请先选择客户')
        return
      }
      if (this.pageSearch.fParkID.length <= 0) {
        this.$message.error('提示：请选择场库')
        return
      }
      if (this.fDate.toString().length <= 0) {
        this.$message.error('提示：请选择日期')
        return
      }
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      var parkArr = (this.park_list || []).filter((item) => {
        return item.fParkID === this.pageSearch.fParkID
      })
      var title = '客户:【' + (custArr.length > 0 ? custArr[0].unionName : '') + '】'
      title += '场库:【' + (parkArr.length > 0 ? parkArr[0].fParkName : '') + '】'
      this.pageSearch.fDate = this.$dateFormat(this.fDate, 'yyyy-MM-dd')
      title += '日期:【' + this.pageSearch.fDate + '】'
      api.getParkPlaceChar(this.pageSearch).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var jsonData = data.Data || []
            var pageData = []
            for (let i = 0; i < jsonData.length; i++) {
              pageData.push(jsonData[i].fRate)
            }
            this.pageDataSet(title, pageData, jsonData)
          } else {
            this.$message.error('提示：加载数据失败')
          }
        }
      })
    },
    init () {
      var today = new Date()
      this.fDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
      // user.getCurrentUserPers({ perTypeId: 69900 }).then(res => {
      //   if (res && res.data) {
      //     var data = res.data
      //     if (data.IsOk) {
      //       if (data.Data) {
      //         this.is_export = data.Data.data.is_export
      //       }
      //     } else {
      //       this.$message.error('提示：加载当前用户权限信息失败')
      //     }
      //   }
      // })
    }
  },
  created () {
  },
  mounted () {
    this.init()
    var pageData = []
    var jsonData = []
    for (let index = 0; index < 24; index++) {
      pageData.push(0)
      jsonData.push({ fBusCurCount: 0, fParkCount: 0 })
    }
    this.pageDataSet('', pageData, jsonData)
  },
  updated () {
  }
}
</script>

<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.danger {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
#main {
  border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/view/report/parkPlaceChar.vue